import { render, staticRenderFns } from "./VencidoEnXDias.vue?vue&type=template&id=ea7306fc&"
import script from "./VencidoEnXDias.vue?vue&type=script&lang=js&"
export * from "./VencidoEnXDias.vue?vue&type=script&lang=js&"
import style0 from "./VencidoEnXDias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea7306fc')) {
      api.createRecord('ea7306fc', component.options)
    } else {
      api.reload('ea7306fc', component.options)
    }
    module.hot.accept("./VencidoEnXDias.vue?vue&type=template&id=ea7306fc&", function () {
      api.rerender('ea7306fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/dashboard/VencidoEnXDias.vue"
export default component.exports